import type { communications as en } from '@/i18n/locales/en/communications';
import type { Translation } from '@/i18n/types';

export const communications: Translation<typeof en> = {
  page: {
    title: 'Comunicazione',
    lead: 'Componi e pianifica notifiche per {{company}}.',
    noScope: 'Seleziona un’azienda per vedere la sua comunicazione.',
    forbidden: 'Non sei autorizzato a vedere la comunicazione di questa azienda.',
  },
  composer: {
    title: 'Nuova notifica',
    titleField: 'Titolo',
    message: 'Messaggio',
    category: 'Categoria',
    audience: 'Pubblico di destinazione',
    date: 'Data',
    time: 'Ora',
    callToAction: 'Invito all’azione',
    quietHours: 'Rispetta le ore di silenzio',
    quietHoursHint: 'Ritarda la consegna al di fuori delle 08:00–20:00.',
    submit: 'Salva come bozza',
    schedule: 'Pianifica',
    send: 'Invia ora',
  },
  categories: {
    algemeen: 'Generale',
    veiligheid: 'Sicurezza',
    evenement: 'Evento',
    vitaliteit: 'Vitalità',
    hr: 'HR',
  },
  audiences: {
    iedereen: 'Tutti',
    management: 'Management',
    per_afdeling: 'Per reparto',
    per_locatie: 'Per sede',
  },
  status: {
    concept: 'Bozza',
    ingepland: 'Pianificato',
    verzonden: 'Inviato',
  },
  log: {
    title: 'Registro invii',
    empty: 'Nessuna comunicazione ancora.',
    columns: {
      message: 'Messaggio',
      category: 'Categoria',
      reach: 'Copertura',
      openRate: 'Tasso di apertura',
      status: 'Stato',
    },
  },
  actions: {
    new: 'Nuova notifica',
    cancel: 'Annulla',
    markScheduled: 'Segna come pianificato',
    markSent: 'Segna come inviato',
  },
};
